// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"668":"24972cdc","701":"6c6e3ef3","904":"c3713cd4"}[chunkId] + ".chunk.css";
};